/** Badge code → label + color token. Backend precomputes `badges: string[]`
 * on each ranking row; the frontend only maps those codes to presentation. */
export type BadgeCode = "manager" | "inactive" | "new" | "plan" | "deactivated";

export interface BadgeStyle {
  label: string;
  /** Tailwind classes for background + text. */
  className: string;
}

const BADGE_STYLES: Record<BadgeCode, BadgeStyle> = {
  manager: {
    label: "Manager",
    className:
      "bg-brand-1/15 text-brand-1 ring-1 ring-inset ring-brand-1/30",
  },
  inactive: {
    label: "Inactivo",
    className:
      "bg-text-4/15 text-text-3 ring-1 ring-inset ring-text-4/30",
  },
  new: {
    label: "Nuevo",
    className:
      "bg-emerald-500/15 text-emerald-400 ring-1 ring-inset ring-emerald-500/30",
  },
  plan: {
    label: "Plan",
    className: "bg-white/5 text-text-2 ring-1 ring-inset ring-white/10",
  },
  deactivated: {
    label: "Desactivado",
    className:
      "bg-amber-500/15 text-amber-400 ring-1 ring-inset ring-amber-500/30",
  },
};

export function badgeStyle(code: string): BadgeStyle {
  if (code in BADGE_STYLES) return BADGE_STYLES[code as BadgeCode];
  return {
    label: code,
    className: "bg-white/5 text-text-3 ring-1 ring-inset ring-white/10",
  };
}
